import React from 'react'
import PropTypes from 'prop-types'

const LandingApplicationProcess = ({ block, onButtonClick }) => {
  const { applicationProcess, imgURL, imgWidth, buttonText, className, isButtonHidden, hasVideo, videoSrc, videoHeight } = block
  return (
    <div className={`row align-items-center px-0 px-md-5 ${className}`}>
      <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 px-0 py-5 p-lg-5 d-flex flex-column flex-lg-row align-items-center'>
        <div className='col-12 col-lg-7 col-xl-6 col-xxl-5 px-0 py-0 py-lg-4'>
          { hasVideo
            ? <iframe src={videoSrc} title='YouTube video player' style={{ width: imgWidth || '100%', height: videoHeight || '100%' }} frameBorder='0' allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowFullScreen></iframe>
            : <img src={imgURL} style={{ width: imgWidth || '100%' }} data-cy='application-process-img' alt='application process image' />
          }
        </div>
        <div className='col-12 col-lg-5 col-xl-6 col-xxl-7 offset-0 offset-xxl-1 px-0 py-4'>
          <div className='ps-0 ps-lg-5 pt-4 pt-lg-0 px-5 px-md-0'>
            <div className='h5 mb-4'>Application Process</div>
            <div className='col-12 px-0'>
              {applicationProcess.map((d, i) => {
                return (
                  <div
                    key={i}
                    className={`d-flex align-items-center ${className === 'bg-white'
                      ? i % 2 === 0 ? 'bg-light' : 'bg-white'
                      : i % 2 === 0 ? 'bg-white' : 'bg-light'}`}
                    style={{ minHeight: '45px' }}>
                    <p className='mb-0 mx-2 py-1 px-3' data-cy='application-process'>{d}</p>
                  </div>
                )
              })}
            </div>
            {!isButtonHidden && <button className='btn btn-primary mt-4' data-cy='application-process-btn' onClick={onButtonClick}>{buttonText}</button>}
          </div>
        </div>
      </div>
    </div>
  )
}

LandingApplicationProcess.propTypes = {
  block: PropTypes.object,
  onButtonClick: PropTypes.func
}

export default LandingApplicationProcess
